import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import TextField from '@material-ui/core/TextField';
import './index.css';
import Utils from '@/common/utils/utils';

function FormInputWithOnChange(props) {
    const { control } = useFormContext();
    const { name, label, required, errorlist, defaultValue,disabled, maxLength, type='text', instruction, instructionClass } = props;
    let isError = false;
    let errorMessage = '';
    if (errorlist && errorlist.hasOwnProperty(name)) {
        isError = true;
        errorMessage = errorlist[name].message;
    }

    const inputRef = React.useRef();
    const handleOnclick = () => {
        inputRef.current.focus();
    };

    const currentValueData = (typeInput, valueInput) => {
        if (typeInput === 'number') {
            if (props?.integerOnly) {
                return valueInput.replace(/[^\d-]/g, '');
            }
            return valueInput.replace(/[^\d.-]/g, '');
        }
        return valueInput;
    }

    return (
        <Controller
            inputRef={inputRef}
            onClick={handleOnclick}
            name={name}
            control={control}
            defaultValue={defaultValue?.toString()?.length ? defaultValue : ''}
            render={({ value, onChange }) => (
            <>
                <TextField
                    value={value}
                    defaultValue={defaultValue?.toString()?.length ? defaultValue : ''}
                    label={label}
                    spellCheck="false"
                    onChange={e => {
                        const inputValue = e.target.value
                        const currentValue = currentValueData(type, inputValue);
                        onChange(currentValue);
                        props.onChange(e);
                    }}
                    onBlur={(e) => {
                        if (props.isDisableOnBlur && !required) {
                            return;
                        }

                        onChange(e.target.value);
                        props.onChange(e);
                    }}
                    disabled={disabled}
                    error={isError}
                    helperText={errorMessage}
                    className={props.className}
                    variant={props.variant}
                    autoComplete="off"
                    rows={props?.rows}
                    multiline={props?.multiline ? props?.multiline : false}
                    inputProps={{
                        maxLength: maxLength,
                        className: `${disabled ? 'fields-disabled' : ''}`,
                        autoComplete: 'new-password',
                        form: {
                        autoComplete: 'off',
                        },
                    }}
                />
                {(!Utils.isEmptyString(instruction)) && (
                    <p className={instructionClass || "email-response-address-instruction font-size-13"}>{instruction}</p>
                )}
            </>
            )}
            rules={{ required: required || false }}
        />
    );
}

export default FormInputWithOnChange;
